import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import {
  Button,
} from "@evos/components";

import type { ReactNode } from "react";
import type { ButtonProps } from "@evos/components/src/components/Button/Button";

type RoleAccessButtonProps = {
  userRoles: string[];
  expectedRole: string;
  children: ReactNode;
  tooltipId: string;
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
};

export default function RoleAccessButton({
  userRoles,
  expectedRole,
  children,
  tooltipId,
  tooltipPlacement = "top",
  ...buttonProps
}: RoleAccessButtonProps & React.ComponentProps<"button"> & ButtonProps) {
  
  if (userRoles.includes(expectedRole)) {
    return (
      <Button {...buttonProps}>
        {children}
      </Button>
    );
  } else {
    return (
      <OverlayTrigger
        placement={tooltipPlacement}
        delay={{ show: 250, hide: 0 }}
        rootClose
        overlay={
          <Tooltip id={`role-access-${tooltipId}`}>
            You do not have the necessary permissions to access this feature (requires {expectedRole} role)
          </Tooltip>
        }
      > 
        <div style={{width: "fit-content"}}>
          <Button
            variant={buttonProps.variant}
            disabled
          >
            {children}
          </Button>
        </div>
      </OverlayTrigger>
    );
  }
}